import angular from 'angular';

module.exports = angular.module('market.routes.static', [
  require('./safety/safety'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/static/index.js
 **/